import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { SearchIcon } from 'tdesign-icons-react';
import { Button, Form, Input, Link, Popconfirm, Table } from 'tdesign-react';
import { deletePermission } from '@/services/tenantService';
import { deal70101, renderDateTime } from '@/utils/common';
import { getPageConfig } from '@/hooks/useTable';
import PermWrapper from '@/components/PermWrapper';
import DisableWrapper from '@/components/DisableWrapper';
import Secret from '@/components/SecretDisplay';
import Modal from './Modal';

const { FormItem } = Form;

export default function QuickGrant({ onUpdate, tenant, tenantAdminRoleList }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');
  const [data, setData] = useState(tenantAdminRoleList);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setData(tenantAdminRoleList);
  }, [tenantAdminRoleList]);

  const columns = [
    {
      colKey: 'roleName',
      title: 'Role',
    },
    {
      colKey: 'roleKey',
      title: '密钥',
      cell: ({ row }) => <Secret>{row.roleKey}</Secret>,
      width: 200,
    },
    {
      colKey: 'roleCreateTime',
      title: '创建时间',
      cell: renderDateTime,
    },
    {
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      align: 'center',
      cell: ({ row }) => (
        <PermWrapper resource='pulsar:tenant:list:delManager'>
          <Popconfirm theme='danger' content='确定删除？' onConfirm={() => handleDel(row)}>
            <DisableWrapper>
              <Link theme='danger' hover='color'>
                移除
              </Link>
            </DisableWrapper>
          </Popconfirm>
        </PermWrapper>
      ),
      width: 120,
    },
  ];

  const handleDel = async (row) => {
    const { meta } = await deletePermission({
      clusterName,
      role: row.roleName,
      tenant,
    });
    // 主集群创建的资源已在灾备集群存在
    if (meta.code === 70101) {
      deal70101(meta.publicMessage, () => handleDel(row), {
        url: '/cluster/tenant/list',
        tenant,
      });
      return;
    }
    onUpdate();
  };

  const handleSearch = async ({ fields }) => {
    const { roleName = '' } = fields;
    setData(tenantAdminRoleList.filter((item) => item.roleName.includes(roleName)));
  };

  const handleClose = (refresh) => {
    setVisible(false);
    if (refresh) {
      // 刷新
      onUpdate();
    }
  };

  return (
    <Root>
      <Header>
        <Form onSubmit={handleSearch} layout='inline'>
          <FormItem name='roleName'>
            <Input placeholder='请输入Role' clearable />
          </FormItem>
          <Button variant='outline' type='submit' icon={<SearchIcon />}>
            搜索
          </Button>
        </Form>
        <PermWrapper resource='pulsar:tenant:list:addManager'>
          <Button
            theme='primary'
            onClick={() => {
              setVisible(true);
            }}
          >
            添加权限
          </Button>
        </PermWrapper>
      </Header>
      <Table
        columns={columns}
        resizable
        maxHeight='50vh'
        pagination={getPageConfig(data)}
        data={data}
      />
      <Modal
        clusterName={clusterName}
        tenant={tenant}
        visible={visible}
        handleClose={handleClose}
      />
    </Root>
  );
}

const Root = styled.div`
  margin-top: 10px;
  margin-right: 20px;
  .t-form-inline .t-form__item {
    margin-right: var(--td-comp-margin-s);
  }
`;

const Header = styled.div`
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
`;

// const Tag = styled.div`
//   background: rgba(102, 136, 255, 0.12);
//   border-radius: 6px;
//   padding: 2px 10px;
//   font-size: 12px;
//   color: #6688ff;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;
